import { Box, type BoxProps } from '@/ui';

export const FilterEmptyState = (props: BoxProps) => (
  <Box
    color="ink.muted"
    fontSize="ah-control"
    py="4"
    textAlign="center"
    {...props}
  />
);
